// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title[data-v-0a54c99b] {\n  font-size: 28px;\n  margin-bottom: 12px;\n}", ""]);
// Exports
module.exports = exports;
